<template>
  <BrandLinksHead
    v-if="brandSettings"
    :brand-settings="brandSettings"
    :title="preview ? latestRevision?.content.title : instantValuation.content.title"
    :fav-icon-source="companyUrl"
  />
  <Component
    :is="layoutComponents[preview ? latestRevision?.content.layout : instantValuation.content.layout]"
    :image="preview ? latestRevision?.content.image : instantValuation.content.image"
    class="bg-white"
  >
    <InstantValuationForm
      :address="address"
      :brand-settings="brandSettings"
      :instant-valuation="instantValuation"
      :instant-valuation-content="preview ? latestRevision?.content : instantValuation.content"
      :street-group-property-id="streetGroupPropertyId"
      :custom-domain="customDomain"
      :postcode="postcode"
    />
  </Component>
</template>

<script setup lang="ts">
import { type Component, onMounted } from 'vue';
import initialiseGtm from '@/Support/InitialiseGtm';
import collect from 'collect.js';
import BrandLinksHead from '@/Components/BrandLinksHead.vue';
import ContentInner from '@/Layouts/InstantValuation/ContentInner.vue';
import ContentRight from '@/Layouts/InstantValuation/ContentRight.vue';
import BlankLayout from '@/Layouts/BlankLayout.vue';
import ContentLeft from '@/Layouts/InstantValuation/ContentLeft.vue';
import ContentBottom from '@/Layouts/InstantValuation/ContentBottom.vue';
import ContentWide from '@/Layouts/InstantValuation/ContentWide.vue';
import ContentNarrow from '@/Layouts/InstantValuation/ContentNarrow.vue';
import ContentInnerHalf from '@/Layouts/InstantValuation/ContentInnerHalf.vue';
import NoBackground from '@/Layouts/InstantValuation/NoBackground.vue';
import ContentInnerLeft from '@/Layouts/InstantValuation/ContentInnerLeft.vue';
import InstantValuationForm from '@/Pages/InstantValuations/Partials/InstantValuationForm.vue';
import InstantValuationData = App.Data.InstantValuation.InstantValuationData;
import RevisionData = App.Data.RevisionData;
import BrandSettingsData = App.Data.Settings.BrandSettingsData;
import CustomDomainData = App.Data.CustomDomainData;

defineOptions({
  layout: BlankLayout,
});

const props = defineProps<{
  address?: string;
  brandSettings: BrandSettingsData;
  instantValuation: InstantValuationData;
  latestRevision: RevisionData | null;
  preview: boolean;
  streetGroupPropertyId?: string;
  companyUrl: string | null;
  customDomain?: CustomDomainData;
  googleTagManager: string | null;
  postcode?: string;
}>();

const layoutComponents = {
  content_inner: ContentInner,
  content_inner_half: ContentInnerHalf,
  content_inner_left: ContentInnerLeft,
  content_left: ContentLeft,
  content_right: ContentRight,
  content_bottom: ContentBottom,
  content_narrow: ContentNarrow,
  content_wide: ContentWide,
  no_background: NoBackground,
} as Record<string, Component>;

onMounted(() => {
  if (typeof window !== 'undefined' && props.googleTagManager && !collect(document.querySelectorAll('script')).pluck('src').contains(`https://www.googletagmanager.com/gtm.js?id=${props.googleTagManager}`)) {
    initialiseGtm(props.googleTagManager);
  }
});
</script>
